export default __webpack_public_path__ + "static/media/RunBuggy.48e77ed0.png";